// extracted by mini-css-extract-plugin
export default {"wrapper":"DataFieldsDropTarget_wrapper__bM81o","over":"DataFieldsDropTarget_over__xyL6d","list":"DataFieldsDropTarget_list__u4HVX"};